import React from "react";

function PanelHeaderButton(props) {
  let className = "btn";
  if (props.extraClassNames) {
    className += " " + props.extraClassNames.join(" ");
  }
  return (
    <a className={className} onClick={props.action}>
      <i className={props.iconClassName} />
    </a>
  );
}

export default PanelHeaderButton;
